import React, {Fragment} from "react";
import AS from '../images/Soltysiak.jpg';
import ASm from '../images/mobile/Soltysiak.jpg';
import RF from '../images/Fetner.jpg';
import RFm from '../images/mobile/Fetner.jpg';
import JS from '../images/Szymczak.jpg';
import JSm from '../images/mobile/Szymczak.jpg';
import content from '../content/people';
import {PageHeader} from "./PageHeader";
import {useContent} from "../customHooks/useContent";
import {TeamMember} from "./TeamMember";
import {generateRandomKey} from "../utils/generateRandomKey";

export const People = () => {
    const addImages = (text) => {
        if (text.people && !text.people[0].image) {
            text.people[0] = {...text.people[0], image: AS, smallImage: ASm};
            text.people[1] = {...text.people[1], image: RF, smallImage: RFm};
            text.people[2] = {...text.people[2], image: JS, smallImage: JSm};
        }

        return text;
    };

    const text = addImages(useContent(content));

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-people"/>
            <main className="people">
                {text.people ? text.people.map(member => <TeamMember data={member} key={generateRandomKey()}/>) : ''}
            </main>
        </Fragment>
    )
};

